import styles from './index.module.css'

import React from 'react'

import type { PlaylistCurated } from 'types/playlist'

import { PlaylistCard } from './playlist-cards/playlist-card'
import { PlaylistInfoText } from './playlist-cards/playlist-info-text'

type CuratedPlaylistCardProps = {
  playlist: PlaylistCurated
  index: number
  isHovered: number | null
  onHover: (_index: number | null) => void
  onClick?: () => void
}

const CuratedPlaylistCard = ({
  playlist,
  index,
  isHovered,
  onHover,
  onClick,
}: CuratedPlaylistCardProps): React.ReactNode => (
  <div className={styles.cardContainer}>
    <PlaylistCard
      playlist={playlist}
      index={index}
      onHover={onHover}
      isHovered={isHovered}
      onClick={onClick}
    />
    <PlaylistInfoText playlist={playlist} />
  </div>
)

export default CuratedPlaylistCard
